/**
 * FR-93/94/96: the server already speaks the user's language (Accept-Language →
 * lang/*.json), so its text beats our generic «Xatolik». Laravel sends
 * `message`; login/OTP refusals send `error`.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === 'object') {
    for (const key of ['message', 'error'] as const) {
      const value = (error as Record<string, unknown>)[key];
      if (typeof value === 'string' && value) return value;
    }
  }
  return fallback;
}
